<mat-form-field class="modal-header-input" appearance="fill" subscriptSizing="dynamic">
  <rma-icon class="chevron-icon" mat-dialog-close glyph="chevron_left" matPrefix />
  @if (showCancelIcon$ | async) {
    <rma-icon class="cancel-icon" [fill]="1" (click)="onClearIconClicked()" matSuffix glyph="cancel" />
  }
  <rma-icon class="search-icon" matPrefix glyph="search" />
  <input
    aria-label="search"
    type="text"
    [placeholder]="'dashboardSearch.searchbox-placeholder' | transloco"
    [formControl]="searchControl"
    mat-input
    matInput
  />
</mat-form-field>

@if (filteredOptions$ | async; as filteredOptions) {
  <div mat-dialog-content>
    @for (group of filteredOptions; track group) {
      <div>
        <strong class="result-group-title">{{ group.section }}</strong>
        @for (option of group.results; track option) {
          <button type="button" class="result-content" [attr.data-id]="option.Title" (click)="onResultClick(option)">
            <rma-icon [glyph]="option.icon" matListItemIcon />
            <div>
              <strong>{{ option.Title }}</strong>
              <p class="result-description">{{ option.Description }}</p>
            </div>
          </button>
        }
      </div>
    }
    @if (filteredOptions?.length === 0) {
      <div class="no-results">
        <rma-search-no-results />
      </div>
    }
  </div>
}

<div mat-dialog-actions align="end">
  <button type="button" mat-button mat-dialog-close color="primary">Close</button>
</div>
